// A guest's "save" goes through sign-in: the candidate's listing page, opened with this flag, saves the
// listing (the server builds the link, the client reads and drops the flag).
export const SAVE_INTENT_PARAM = 'save';
